import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Paper,
  ImageList,
  ImageListItem
} from '@mui/material';

const ConfirmationPage = ({ submittedData, onReturn, theme, t }) => {
  const formatDate = (date) => {
    if (!date) return '-';
    const d = new Date(date);
    return d.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  return (
    <Box sx={{ 
      maxWidth: 800, 
      mx: 'auto', 
      p: 3, 
      mt: 4,
      fontFamily: theme.fontFamily
    }}>
      <Paper 
        elevation={0}
        sx={{ 
          p: 4,
          borderRadius: 2,
          backgroundColor: theme.background,
          border: `1px solid ${theme.primary}40`
        }}
      >
        <Typography 
          variant="h4" 
          component="h1" 
          gutterBottom
          sx={{ 
            mb: 3,
            color: theme.primary,
            fontWeight: 'bold',
            textAlign: 'center'
          }}
        >
          {t.thankYou}
        </Typography>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom sx={{ color: theme.text, mb: 2 }}>
            {t.reportDetails}:
          </Typography>
          
          <Box sx={{ display: 'grid', gap: 2 }}>
            {submittedData.name && (
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  {t.name}
                </Typography>
                <Typography>{submittedData.name}</Typography>
              </Box>
            )}

            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                {t.email}
              </Typography>
              <Typography>{submittedData.email}</Typography>
            </Box>

            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                {t.date}
              </Typography>
              <Typography>{formatDate(submittedData.date)}</Typography>
            </Box>

            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                {t.type}
              </Typography>
              <Typography>
                {submittedData.isPublic === 'public' ? t.public : t.private}
              </Typography>
            </Box>

            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                {t.platform}
              </Typography>
              <Typography>
                {submittedData.platform === 'other' 
                  ? submittedData.otherPlatform || t.other
                  : submittedData.platform}
              </Typography>
            </Box>

            {submittedData.link && (
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  {t.link}
                </Typography>
                <Typography 
                  component="a" 
                  href={submittedData.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: theme.primary }}
                >
                  {submittedData.link}
                </Typography>
              </Box>
            )}

            {submittedData.comments && (
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  {t.comment}
                </Typography>
                <Typography sx={{ whiteSpace: 'pre-wrap' }}>
                  {submittedData.comments}
                </Typography>
              </Box>
            )}
          </Box>

          {submittedData.attachmentUrls?.length > 0 && (
            <Box sx={{ mt: 3 }}>
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                {t.screenshot}
              </Typography>
              <ImageList 
                sx={{ 
                  width: '100%',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))!important'
                }} 
                gap={8}
              >
                {submittedData.attachmentUrls.map((url, index) => (
                  <ImageListItem 
                    key={index}
                    sx={{ 
                      border: `1px solid ${theme.primary}20`,
                      borderRadius: '4px',
                      overflow: 'hidden'
                    }}
                  >
                    <img
                      src={url}
                      alt={`${t.screenshot} ${index + 1}`}
                      loading="lazy"
                      style={{ 
                        width: '100%',
                        height: '200px',
                        objectFit: 'cover'
                      }}
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            </Box>
          )}
        </Box>

        <Button
          variant="contained"
          fullWidth
          onClick={onReturn}
          sx={{ 
            mt: 2,
            py: 1.5,
            fontWeight: 'bold',
            fontSize: '1.1rem',
            bgcolor: theme.primary,
            boxShadow: 'none',
            '&:hover': {
              bgcolor: theme.secondary,
              boxShadow: 'none'
            }
          }}
        >
          {t.returnToForm}
        </Button>
      </Paper>
    </Box>
  );
};

export default ConfirmationPage; 